import { useCallback, useMemo, useRef } from "react";

/** Discards responses belonging to a source the user has already left. */
export function useSourceRequestGuard(): {
  invalidate: () => void;
  capture: () => () => boolean;
} {
  const generation = useRef(0);
  const invalidate = useCallback(() => {
    generation.current += 1;
  }, []);
  const capture = useCallback(() => {
    const startedAt = generation.current;
    return () => startedAt === generation.current;
  }, []);
  return useMemo(() => ({ invalidate, capture }), [invalidate, capture]);
}
